module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-injekcni-metody_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/laserova-estetika/vyhlazeni-vrasek-injekcni-metody_4_before.jpg
// module id = 1024
// module chunks = 0